import { Form, Grid, Select } from '@approvalmax/ui/src/components';
import { domHelpers } from '@approvalmax/utils';
import { FC } from 'react';

import { messages } from './CurrencySection.messages';
import { CurrencySectionProps } from './CurrencySection.types';

export const CurrencySection: FC<CurrencySectionProps> = (props) => {
    const { qa, currencies } = props;

    return (
        <Form.Part>
            <Grid gridTemplateColumns='1fr 1fr' gap={16}>
                <Select
                    name='defaultCurrency'
                    itemNameKey='text'
                    qa={domHelpers.generateDataQa(qa, 'currency')}
                    label={messages.defaultCurrencyLabel}
                    placeholder={messages.placeholder}
                    items={currencies}
                    autocomplete
                />
            </Grid>
        </Form.Part>
    );
};

CurrencySection.displayName = 'CurrencySection';
